export default {
  feedbacks: {
    loading: false,
    error: '',
    count: 0,
    total: 0,
    page: 0,
    paging: 10,
    sortBy: 'createdAt',
    sortDirection: 'DESC',
    filter: '',
    feedbackList: [],
    selectedBookmark: 'main',
    categories: [],
    file: null,
    selectedCategories: [],
    withComment: null,
    withReaction: null,
    rating: null,
  },
  bookmarks: {
    loading: false,
    error: '',
    bookmarks: [],
    users: [],
  }
};
